module.exports = __webpack_public_path__ + "img/free.3cbfa373.svg";